/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useMemo, useState} from "react";
import {Button, Grid, IconButton, InputAdornment, Paper, Stack, TextField, ThemeProvider} from "@mui/material";
import {SEText} from "../../../../components/SEText";
import {ProjetoAcaoService} from "../services";
import useRenderFormStore from "../../stores/useRenderFormStore";
import {BaSeDialogContext} from "@base/react";
import theme from "../../../../mui-theme";
import {useHistory} from "react-router-dom";
import {useLocation, useParams} from "react-router";
import {SEFormUserAction} from "../../../../components/SEFormUserAction";
import {Controller, useFieldArray, useForm} from "react-hook-form";
import {handleModalRedirect} from "../../../../../utils/handleModalRedirect";
import {handleModalStatus} from "../../../../../utils/handleModalStatus";
import {RiSearchLine} from "react-icons/ri";
import ActionsGroup from "../Components/ActionsGroup";
import {sortByDirection} from "../../../../../utils/utils";
import useFormMutation from "../../hooks/useFormMutation";
import {removeEmpty} from "../../../../utils/utils";
import SEFilterSelect from "../../../../components/SEFilterSelect";
import styled from "styled-components";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import {ImCancelCircle} from "react-icons/im";
import styles
    from "../../../../../pages/tabelasDeControle/components/RegrasContabilizacao/IncluirRegrasContabilizacao/styles.module.scss";
import {BsPlusCircle} from "react-icons/bs";
import {TextFieldCounter} from "../../../../components/TextFieldCounter";
import {
    ContentSpinner
} from "../../../../../pages/tabelasDeControle/components/ProjetosAcoes/IncluirProjetoAcoes/incluir-styled";
import Spinner from "react-spinner-material";
import {ProjetoAcoesService} from "../../../../../pages/tabelasDeControle/services/projetoAcoesService";


const CustomIcon = styled(RiSearchLine)(({theme}) => ({
    fill: theme.palette.primary.main,
    height: 26,
    width: 26,
    top: "calc(50% - .75em) !important",
}));


interface Regional {
    descricao: string | null;
    uf: string | null;
    acao: string | null;
}

interface Projeto {
    id?: any;
    cpf?: any;
    nomePratif: string | null;
    regionais: Regional[];
    acoes?: any[]
}

const Formulario = () => {

    const {showModal} = React.useContext(BaSeDialogContext);
    const history = useHistory();
    const location = useLocation();
    const {id} = useParams<{
        id: string
    }>();
    const hasCopyParam = location.pathname.includes('/copy');

    const {formData: editFormData,  handleShowForm} = useRenderFormStore();

    const [data, setData] = useState<any>({
        nomePratif: '',
        acoes: [],
        regionais: [{
            descricao: '',
            uf: null,
            acao: null,
        }]
    });

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [isPratif, setIsPratif] = useState<boolean>(false);

    const [numPratif, setNumPratif] = useState<any>('');

    const [errorPratif] = useState<any>(null);

    const {watch, control, handleSubmit, formState, reset} = useForm<Projeto>({
        defaultValues: useMemo(() => {
            return data;
        }, [data]),
    });

    useEffect(() => {
        if (id && data?.acoes?.length) {
            setIsPratif(true);
            setIsLoading(false);
            findRegionais(data)
        }
        reset(data)
    }, [data]);

    useEffect(() => {
        if (editFormData?.nuPratif) {
            setNumPratif(editFormData?.nuPratif)
        }
    }, [editFormData]);

    const findProjeto = (idProjeto: any) => {
        ProjetoAcoesService.findById(idProjeto).then((response) => {
            setData(response)
            if (!numPratif) {
                setNumPratif(response?.nuPratif)
            }
        });
    };

    const onResetFields = () => {
        reset({
            nomePratif: '',
            regionais: [{
                descricao: '',
                uf: null,
                acao: null,
            }]
        });
    };

    const goBack = async () => {
        reset({
            nomePratif: '',
            regionais: [{
                descricao: '',
                uf: null,
                acao: null,
            }]
        });
        handleShowForm(false)
        history.push(`/tabelas-de-controle/projetos-acoes`);
    };

    const handleRemoveRegional = (index: any) => {
        const regionais = watch('regionais');
        if (regionais?.length === 1) return;
        removeRegionais(index);
    }

    useEffect(() => {

        const isEditing = history.location.pathname.includes("/edit");
        if (isEditing && numPratif) {
            handleClickPratif(numPratif);
        }
        if (isEditing && !numPratif) {
            setIsLoading(true)
            findProjeto(id)
        }
        // eslint-disable-next-line
    }, []);


    const handleEditClick = (id: any) => {
        history.push(`/tabelas-de-controle/projetos-acoes/${id}/edit`);
    };

    const handleHasPratif = (item: any) => {
        setIsPratif(false);
        handleModalRedirect({
            title: 'Projeto e ação',
            content: 'Projetos e ações já existe, deseja editar projetos e ações?',
            onFinish: () => handleEditClick(item),
            // onConfirmClick: () => handleEditClick(item),
            onCancelClick: () => console.log('modal closed...'),
            showModal: showModal,
        });
    };
    const handleNotPratif = () => {
        handleModalStatus({
            type: 'erro',
            titleOnError: 'Não Encontrado',
            msgOnError: 'Código PRATIF não existe ou não foi encontrado!',
            onCloseModal: () => console.log('modal closed...'),
            showModal,
        });
    };

    const acoesSelecionadas = watch('acoes');

    const {isSubmitting} = formState;

    const {
        replace: replaceRegionais,
        fields: regionais,
        append: appendRegionais,
        remove: removeRegionais,

    } = useFieldArray({
        control,
        name: 'regionais',
        rules: {},
    });

    const {
        createMutation,
        updateMutation,
    } = useFormMutation({
        showModal,
        service: ProjetoAcaoService,
        onCloseModalSuccess: () => {
            onResetFields();
            goBack()
        },
        onCloseModalUpdate: () => goBack(),
        onCloseModalError: () => {
        },
    });


    const submitForm = async (dataForm: Projeto) => {
        try {
            const cleanedData = removeEmpty(dataForm);

            const response: any = cleanedData?.id
                ? await updateMutation(cleanedData)
                : await createMutation(cleanedData)

            if (response && acoesSelecionadas?.length === 1) {
                const dataFormaRegionais = dataForm?.regionais?.map(f => ({
                    descricao: f?.descricao,
                    acao: response.acoes[0],
                    uf: response.uf
                }));
                const hasRegionalFilled = dataFormaRegionais.find(r => r.descricao);
                if (hasRegionalFilled) {
                    await ProjetoAcaoService.editRegionais(dataFormaRegionais);
                }
            }
        } catch (e) {
            console.log('deu erro', e)
        }

    }

    const findRegionais = async (data: any) => {
        const acao = data?.acoes?.filter((d: any) => d.id)?.[0]
        if (!acao?.id) return;
        try {
            const response = await ProjetoAcaoService.findRegionaisById(acao?.id)
            replaceRegionais([]);
            if (!response.length) {
                replaceRegionais({
                    descricao: '',
                    uf: null,
                    acao: null,
                })
                return;
            }
            // @ts-ignore
            const regionais = sortByDirection(response, 'id', 'ASC');
            replaceRegionais(regionais);
        } catch (e) {
            console.log('erros regionais', e);
        }
    };

    const resetData = (response: any) => {
        const {
            acoes,
            uf,
            id,
            nomePratif,
            nuPratif,
            codigoProjeto,
        } = response;

        if (acoes.length) {
            acoes.forEach((a: any) => {
                delete a?.descricao
                a.id = null
            })
        }

        setData({
            acoes,
            codigoProjeto,
            uf,
            id,
            nomePratif,
            nuPratif
        });
        setIsLoading(false)
        setIsPratif(true);
    }

    const handleClickPratif = async (valuePratif: any) => {
        try {

            setIsLoading(true);
            setIsPratif(false);

            const isEditing = history.location.pathname.includes("/edit");

            if (isEditing) {
                findProjeto(id);
            } else {
                const response = await ProjetoAcaoService.findPratif(valuePratif);

                if (!response?.nuPratif) {
                    setIsLoading(false);
                    handleNotPratif();
                    return;
                }

                if (!isEditing && response?.id && response?.statusAprovacao !== 'REPROVADO') {
                    setIsLoading(false);
                    setIsPratif(false);
                    handleHasPratif(response?.id);
                    return;
                }
                resetData(response)
            }


        } catch (err) {
            console.log('err', err);
        }
    };


    return (
        <Paper
            sx={{
                display: "flex",
                alignItems: "center",
                padding: 2,
            }}
        >
            <ThemeProvider theme={theme}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <SEText
                            as="h2"
                            size={"medium"}
                            font="Mulish"
                            weight="bold"
                            color="#7B80FF"
                        >
                            {editFormData?.id ? (hasCopyParam ? 'Copiar' : 'Editar') : 'Incluir'}
                        </SEText>
                    </Grid>

                    <Grid container item spacing={3}>

                        <Grid item md={12} container spacing={3}>
                            <Grid item md={4} spacing={2}>
                                <TextField
                                    id="cpf"
                                    label="Cód. PRATIF *"
                                    placeholder="Digite um código PRATIF válido"
                                    fullWidth
                                    value={numPratif}
                                    onChange={(event) => setNumPratif(event?.target?.value)}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    disabled={!numPratif?.length}
                                                    aria-label="search"
                                                    onClick={() => handleClickPratif(numPratif)}
                                                >
                                                    <RiSearchLine/>
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                {errorPratif && (
                                    <p style={{color: "red", marginTop: "8px"}}>
                                        {errorPratif.message}
                                    </p>
                                )}
                            </Grid>

                            {isLoading ? (
                                <ContentSpinner>
                                    <Spinner radius={20} color={'#0061C6'} stroke={2} visible={true}/>
                                    <p
                                        style={{color: '#ccc', fontSize: '12px', marginLeft: '0.5rem'}}
                                    >
                                        Buscando PRATIF...
                                    </p>
                                </ContentSpinner>
                            ) : isPratif ? (
                                <Grid item md={2}>
                                    <SEFilterSelect
                                        displayField={'sigla'}
                                        id={"uf"}
                                        defaultOption={"Selecione a UF"}
                                        IconComponent={CustomIcon}
                                        label="UF *"
                                        value={data?.uf ?? 'UF'}
                                        onChange={() => null}
                                        options={[data?.uf]}
                                    />
                                </Grid>
                            ) : (
                                ''
                            )}

                        </Grid>
                        {isPratif ? (
                            <>
                                <Grid item md={12}>
                                    <Controller
                                        control={control}
                                        name="nomePratif"
                                        rules={{required: "Este campo é obrigatório"}}
                                        render={({
                                                     field: {value, onChange},
                                                     fieldState: {error},
                                                 }) => (
                                            <>
                                                <TextField
                                                    id="nome"
                                                    label="Nome do projeto *"
                                                    placeholder="Digite o nome do projeto"
                                                    fullWidth
                                                    value={value ?? ""}
                                                    onChange={onChange}
                                                    inputProps={{maxLength: 140}}
                                                />
                                                {error && (
                                                    <p style={{color: "red", marginTop: "8px"}}>
                                                        {error.message}
                                                    </p>
                                                )}
                                            </>
                                        )}
                                    />
                                </Grid>

                                <Grid item md={12}>
                                    <ActionsGroup
                                        actions={data?.acoes}
                                        nameAction="nomeAcao"
                                        descAction="descricao"
                                        id="codAcao"
                                        name="acoes"
                                        control={control}
                                        title="Ações"
                                        title2="Descrição no app"
                                    />
                                </Grid>
                            </>
                        ) : null
                        }

                        <Grid item md={12}>
                            {
                                (acoesSelecionadas?.length === 1) && (
                                    <Stack direction="column" spacing={2}>
                                        <Stack>
                                            <Typography><b>Regionais</b></Typography>
                                            <Typography mt={2} mb={2}><b>Descrição no app</b></Typography>
                                        </Stack>
                                        {regionais.map((item, index) => (
                                            <Grid key={index} container item>
                                                <Grid item md={6}>
                                                    <Controller
                                                        name={`regionais.${index}.descricao`}
                                                        control={control}
                                                        rules={{required: "Este campo é obrigatório"}}
                                                        render={({
                                                                     field: {value, onChange},
                                                                     fieldState: {error},
                                                                 }) => (
                                                            <>
                                                                <TextField
                                                                    name={`regionais.${index}.descricao`}
                                                                    fullWidth
                                                                    value={value ?? ""}
                                                                    onChange={onChange}
                                                                    inputProps={{maxLength: 140}}
                                                                />
                                                                <TextFieldCounter value={item.descricao} maxLength={140}/>
                                                                {error && (
                                                                    <p style={{color: "red", marginTop: "8px"}}>
                                                                        {error.message}
                                                                    </p>
                                                                )}
                                                            </>
                                                        )}
                                                    />
                                                </Grid>
                                                <Grid mx={2} item md={2} gap=".3rem" alignItems={"center"}>
                                                    <Tooltip title="Delete">
                                                        <div>
                                                            <ImCancelCircle
                                                                size={20}
                                                                color="#F4455A"
                                                                onClick={() => handleRemoveRegional(index)}
                                                            />
                                                        </div>
                                                    </Tooltip>
                                                    <Tooltip title="Adicionar">
                                                        <div>
                                                            <button
                                                                type="button"
                                                                className={styles.actionsButtonAdd}
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    display: index === 0 ? '' : 'none',
                                                                }}
                                                                onClick={() => {
                                                                    appendRegionais({
                                                                        descricao: null,
                                                                        uf: null,
                                                                        acao: null
                                                                    });
                                                                }}
                                                            >
                                                                <BsPlusCircle size={20} color="#0061C6"/>
                                                            </button>
                                                        </div>
                                                    </Tooltip>
                                                </Grid>
                                            </Grid>
                                        ))}
                                    </Stack>
                                )
                            }
                        </Grid>
                    </Grid>


                    <Grid item md={12} display="flex" justifyContent="flex-end" gap={2}>
                        <Button type={"button"} variant="outlined" onClick={() => goBack()}>
                            Cancelar
                        </Button>
                        <Button
                            type={"button"}
                            variant="contained"
                            onClick={handleSubmit(submitForm)}
                            disabled={isSubmitting}
                        >
                            {editFormData?.id ? (hasCopyParam ? 'Incluir' : 'Editar') : 'Incluir'}
                        </Button>
                    </Grid>

                    <Grid item md={12}>
                        <SEFormUserAction data={editFormData}/>
                    </Grid>
                </Grid>
            </ThemeProvider>
        </Paper>
    );
};

export default Formulario;
